import React from "react"
import { IconWrapper, IconPath } from "shared/Styles/Icons"
import { withTheme } from "styled-components"

const VirtualReality = withTheme(({ theme }) => (
  <IconWrapper
    width="80px"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 253 125.7"
    xmlSpace="preserve"
  >
    <IconPath
      color={theme.color.white}
      style={{ fillRule: "evenodd", clipRule: "evenodd" }}
      d="M188.6,55.2c0,1.1-0.9,2.1-2.1,2.1c-1.1,0-2.1-0.9-2.1-2.1V40c0-1.1,0.9-2.1,2.1-2.1h30.2V27.4h-33l-18,28.7
	c-0.6,1-1.9,1.3-2.8,0.6c-0.3-0.2-0.5-0.4-0.7-0.7l-18.6-29.6c-0.6-1-0.3-2.2,0.6-2.8c1-0.6,2.2-0.3,2.8,0.6L164,51.1l16.8-26.8
	c0.3-0.7,1-1.1,1.8-1.1h36.2c1.1,0,2.1,0.9,2.1,2.1V40c0,1.1-0.9,2.1-2.1,2.1h-5l7.1,12.2c0.6,1,0.2,2.2-0.8,2.8
	c-1,0.6-2.2,0.2-2.8-0.8l-8.2-14.3h-20.5V55.2L188.6,55.2z M146.6,8.9V7c0-0.8-0.3-1.5-0.8-2c-0.5-0.5-1.2-0.8-2-0.8h-31.4
	c-0.8,0-1.5,0.3-2,0.8c-0.5,0.5-0.8,1.2-0.8,2v1.9H146.6L146.6,8.9z M30.5,8.9c-2.8,0-5.4,0.5-7.9,1.6c-2.4,1.1-4.6,2.6-6.5,4.7
	c-1.9,2.1-3.2,4.4-3.9,6.9c-0.6,1.9-0.9,3.9-1,6H7c-1.9,0-3.7,0.8-4.9,2c-1.3,1.3-2,3-2,4.9V70c0,1.9,0.8,3.7,2.1,4.9
	C3.3,76.2,5.1,77,7,77h5.6l1,30.9c0,5,2.2,9.4,5.7,12.5c3.6,3.3,8.5,5.2,13.6,5.2h65.9c3.7,0,7.1-1,10.1-2.7
	c2.9-1.8,5.4-4.4,7.1-7.6l0.4-0.8c0.9-1.6,2.1-2.9,3.5-3.8c1.4-0.9,3.2-1.4,5-1.4h3.5c1.8,0,3.6,0.5,5,1.3c1.4,0.9,2.7,2.2,3.5,3.8
	l0.4,0.8c1.7,3.3,4.2,5.9,7.1,7.6c2.9,1.8,6.4,2.7,10.1,2.7l66.7,0c4.8,0,9.5-1.8,13-4.7c3.6-3,6-7.2,6-12.2l0.7-31.8h5.2
	c1.9,0,3.7-0.8,4.9-2.1c1.3-1.3,2.1-3,2.1-4.9V35.2c0-1.9-0.8-3.7-2-4.9c-1.3-1.3-3-2-4.9-2h-4.3c-0.1-1.9-0.3-3.7-0.8-5.5
	c-0.7-2.6-1.8-5-3.8-7.2c-1.9-2.2-4.1-3.8-6.6-5c-2.5-1.1-5.1-1.7-8-1.7h-71.8V7c0-1.9-0.8-3.7-2-4.9c-1.3-1.3-3-2-4.9-2h-31.4
	c-1.9,0-3.7,0.8-4.9,2.1c-1.3,1.3-2.1,3-2.1,4.9v1.9H30.5L30.5,8.9z M241.8,32.3h4.2c0.8,0,1.5,0.3,2,0.8c0.5,0.5,0.8,1.2,0.8,2V70
	c0,0.8-0.3,1.5-0.8,2c-0.5,0.5-1.2,0.8-2,0.8h-5.1L241.8,32.3L241.8,32.3z M12.5,72.9H7c-0.8,0-1.5-0.3-2-0.8
	c-0.5-0.5-0.8-1.2-0.8-2V35.2c0-0.8,0.3-1.5,0.8-2c0.5-0.5,1.2-0.8,2-0.8h4.3L12.5,72.9L12.5,72.9z M222.6,13H30.5
	c-2.2,0-4.3,0.4-6.2,1.2c-1.9,0.8-3.6,2.1-5.1,3.7c-1.5,1.6-2.5,3.4-3,5.4c-0.6,2-0.8,4.2-0.8,6.5l2.4,78c0,3.8,1.7,7.1,4.4,9.5
	c2.8,2.6,6.7,4.1,10.8,4.1h65.9c2.9,0,5.6-0.8,7.9-2.1c2.3-1.4,4.2-3.4,5.6-6l0.4-0.8c1.2-2.3,3-4.2,5-5.4c2.1-1.3,4.5-2,7.1-2h3.5
	c2.6,0,5.1,0.7,7.1,1.9c2.1,1.3,3.8,3.1,5,5.4l0.4,0.8c1.3,2.6,3.3,4.6,5.6,6c2.3,1.4,5,2.1,7.9,2.1h66.7c3.8,0,7.6-1.4,10.4-3.8
	c2.7-2.3,4.5-5.4,4.5-9l1.7-78.2c0-2.4-0.2-4.7-0.7-6.8c-0.5-2-1.4-3.9-2.9-5.5c-1.5-1.7-3.2-3-5.2-3.9C227,13.5,224.9,13,222.6,13z
	"
    ></IconPath>
  </IconWrapper>
))

export { VirtualReality }
